import Header from "../component/Header";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import ReportDetails from "../component/ReportDetails";

const Examination = () => {
  return (
    <>
      <Header />
      <NavBar />
      <ReportDetails />
      <Footer />
    </>
  );
};

export default Examination;
